import React, { FC, useEffect } from "react";

interface Props {
  path: string;
}

const Adsense: FC<Props> = ({ path }) => {
  useEffect(() => {
    if (window) {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }, [path]);
  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block", textAlign: "center" }}
      data-ad-client="ca-pub-1700527531354838"
      data-ad-slot="2717584754"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default Adsense;
